import React from 'react';

/**
 * Site-wide LocalBusiness schema is now in public/index.html as static JSON-LD
 * for guaranteed crawlability without JavaScript.
 *
 * This component is kept as a no-op for backwards compatibility with App.js imports.
 * To update the LocalBusiness schema, edit public/index.html.
 */
const SEOSchema = () => null;

export default SEOSchema;
